import http from '@root/utils/axios/admin';

let state = {
    SettingsList: [],
    Setting: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchSettingsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/settings', { params: filter }).then((response) => {
                commit('setSettings', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteSetting({ commit }, id) {
        return http.delete('/api/settings/' + id);
    },

    fetchSetting({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/settings/' + id).then((response) => {
                commit('setSetting', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateSetting({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/settings', data).then((response) => {
                commit('setSetting', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setSettingError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateSetting({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/settings/' + data.id, data).then((response) => {
                commit('setSetting', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setSettingError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    updateSettingFormData({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/settings/' + data.get('id'), data).then((response) => {
                commit('setSetting', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setSettingError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setSettings(state, data) {
        state.SettingsList = data;
    },
    setSetting(state, data) {
        state.Setting.data = data;
    },
    setSettingError(state, error) {

        state.Setting.error = error.errors;
    },
    cleanSettingError(state, error) {
        state.Setting.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}